import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
import { ref } from 'vue';
import { appRoutes } from './routes';
import { REDIRECT_MAIN, NOT_FOUND_ROUTE } from './routes/base';
import createRouteGuard from './guard';

NProgress.configure({ showSpinner: true }); // NProgress Configuration

const router = createRouter({
  history: process.env.NODE_ENV === 'production' ? createWebHistory() : createWebHashHistory(), 
  routes: [
    {
      path: '/',
      redirect: 'home',
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/home/index.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/indexNew.vue'), // 需要改
      meta: {
        requiresAuth: false,
        title: '登录'
      },
    },
    {
      path: '/stepVerification',
      name: 'StepVerification',
      component: () => import('@/views/login/verification.vue'), // 需要改
      meta: {
        requiresAuth: false,
        title: '登录'
      },
    },
    {
      path: '/resigter',
      name: 'Resigter',
      component: () => import('@/views/resigter/index.vue'),
      meta: {
        requiresAuth: false,
        title: '注册'
      },
    },
    {
      path: '/registerVer',
      name: 'RegisterVer',
      component: () => import('@/views/resigter/verification.vue'),
      meta: {
        requiresAuth: false,
        title: '注册'
      },
    },
    {
      path: '/forgetPassword',
      name: 'ForgetPassword',
      component: () => import('@/views/forget/index.vue'),
      meta: {
        requiresAuth: false,
        title: '忘记密码'
      },
    },
    {
      path: '/forgetVerification',
      name: 'ForgetVerification',
      component: () => import('@/views/forget/step2.vue'),
      meta: {
        requiresAuth: false,
        title: '忘记密码'
      },
    },
    {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: () => import('@/views/forget/step3.vue'),
      meta: {
        requiresAuth: false,
        title: '忘记密码'
      },
    },
    {
      path: '/serviceAgreement',
      name: 'ServiceAgreement',
      component: () => import('@/views/login/service.vue'),
      meta: {
        requiresAuth: false,
        title: '服务条款'
      },
    },
    {
      path: '/privacyPolicy',
      name: 'PrivacyPolicy',
      component: () => import('@/views/login/privacy.vue'),
      meta: {
        requiresAuth: false,
        title: '隐私政策'
      },
    },
      {
      path: '/down',
      name: 'Down',
      component: () => import('@/views/down/index.vue'),
      meta: {
        requiresAuth: false,
        // title: '下载钱包'
      },
    },
    // {
    //   path: '/unblockacc',
    //   name: 'Unblockacc',
    //   component: () => import('@/views/unblockacc/index.vue'),
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
       {
      path: '/submit',
      name: 'submit',
      component: () => import('@/views/unblockacc/submit.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    // @ts-ignore
    ...appRoutes,
    // @ts-ignore
    REDIRECT_MAIN,
    // @ts-ignore
    NOT_FOUND_ROUTE,
  ],
  scrollBehavior() {
    return { top: 0 };
  }, 
});



createRouteGuard(router);

export default router;
